export default "__VITE_ASSET__ae609bbe__"